import { Portal } from '@/app/_components/Portal/Portal'
import { PORTAL_SELECTORS } from '@/config/navigation.config'
import { ReactNode, useContext } from 'react'
import LoginContext from '@/app/_providers/LoginProvider/LoginContext'
import TXT from '@/messages'

type Props = {
  hasLifetimeTickets: boolean
}

/* This portal tells the EventLocationCard (in EventDetails) if an event has a Lifetime ticket type
   if the lifetime ticket type is present we show the infinity symbol to signify that the
   event is Lifetime Pass holder Eligible.
   Todo: revisit moving timeslotData query up 2 levels in the tree and removing this portal

   only show the lifetime icon to logged out users
   or lifetime pass holders
*/
const LifetimeIndicator = ({ hasLifetimeTickets }: Props): ReactNode => {
  const { user, membershipDetails } = useContext(LoginContext)

  if (!hasLifetimeTickets) {
    return null
  }

  // if user and the user does not have lifetime pass, return null
  if (user && !membershipDetails?.isLifetimePass) {
    return null
  }

  return (
    <Portal selector={`#${PORTAL_SELECTORS.lifeTimePass}`}>
      <img
        data-testid="lifetime-icon"
        src="/static/events/svg/infinity.svg"
        alt={TXT.eventsA11y.infinityIcon}
      />
    </Portal>
  )
}

export default LifetimeIndicator
